import styled, { css } from 'styled-components'
import { themeStyles } from '../../../styles/theme'

export const Container = styled.div`
  display: inline-flex;
  gap: 4px;
  padding: 4px 5px;
  background-color: ${themeStyles.colors.darkGreys[3].main};
  border-radius: 3px;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: 0.4em;
  }

  ${({ isExpiring }) =>
    isExpiring &&
    css`
      background-color: ${themeStyles.colors.products.casino.main};
    `}
`

export const Value = styled.p`
  font-size: 13px;
  font-weight: 700;
  margin: 0 !important;
  min-width: 82px;

  ${({ isExpiring }) =>
    isExpiring &&
    css`
      min-width: 64px;
    `}
`

export const Clock = styled.div`
  align-items: center;
  justify-content: center;
  border-radius: 100%;
`
